




























interface LocalProps {
  range: PropOptions;
  value: PropOptions;
  startText: PropOptions;
  endText: PropOptions;
}

export default {
  name: 'HMOpinionScale',
  props: {
    range: {
      type: Number,
      default: null,
    },
    value: {
      type: Number,
      default: null,
    },
    startText: {
      type: String,
      default: null,
    },
    endText: {
      type: String,
      default: null,
    },
  } as LocalProps,
};
